/**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import clsx from "clsx";
import { FC, RefObject } from "react";
import { createUseStyles } from "react-jss";
import { useSelector } from "react-redux";

import { JSS_MEDIA_DESKTOP_MIN, JSS_MEDIA_TABLET_MAX } from "~/constants";
import { selectAuthAccount } from "~/features/auth/selectors";
import AuthenticatedMenuContent from "~/features/header/components/menucontent/AuthenticatedMenuContent";
import GuestMenuContent from "~/features/header/components/menucontent/GuestMenuContent";

const useStyles = createUseStyles({
  nav: {
    "& $navList": {
      padding: 0,
    },
  },
  navList: {
    display: "grid",
    listStyle: "none",
    "& li": {
      padding: 0,
    },
    [JSS_MEDIA_TABLET_MAX]: {
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridRowGap: "24px",
    },
    [JSS_MEDIA_DESKTOP_MIN]: {
      gridAutoFlow: "column",
      gridAutoColumns: "auto",
      gridColumnGap: "24px",
      alignItems: "end",
    },
  },
});

interface Props {
  navRef?: RefObject<HTMLElement | null>;
  className?: string;
}

const MenuContent: FC<Props> = ({ navRef, className }) => {
  const classes = useStyles();

  const account = useSelector(selectAuthAccount);

  return (
    <nav className={clsx(classes.nav, className)} ref={navRef}>
      <ul className={classes.navList}>{account ? <AuthenticatedMenuContent /> : <GuestMenuContent />}</ul>
    </nav>
  );
};

export default MenuContent;
